import { MiddlewareAPI, PayloadAction } from '@reduxjs/toolkit'

import SocketClient from 'store/reducers-common/Socket/socketClient'

import { emitClaimEvent } from './claimEvents'
import { events } from './events'

const isNotEmptyArrayOrEmptyObject = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0
  }
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length > 0
  }
  return false
}

export const socketMiddleware =
  () => (api: MiddlewareAPI) => (next) => (action: PayloadAction<{ query: string; socket: SocketClient }>) => {
    const { payload, type } = action
    switch (type) {
      case 'socket/connect': {
        payload.socket.connect(payload.query)
        payload.socket.on('message', (eventsData) => {
          Object.keys(eventsData).forEach((key) => {
            if (isNotEmptyArrayOrEmptyObject(eventsData[key]) && events[key]) {
              const onEventsActions = events[key]
              onEventsActions.forEach((eventAction) => {
                api.dispatch(eventAction(eventsData[key]))
              })
              if (key === 'DepositClaimedEvent' || key === 'RedeemClaimedEvent') {
                emitClaimEvent(key, eventsData[key])
              }
            }
          })
        })
        break
      }
      case 'socket/disconnect': {
        payload.socket?.disconnect()
        break
      }
      default:
        break
    }

    return next(action)
  }
